<template>
  <BgImageLayout title="Imported subscriptions">
    <AgGridWrapper :options="gridOptions" :include-search-box="true" title="Previous imports" />
  </BgImageLayout>
</template>

<script>
import * as apiTo from '@/modular-api'
import gridOptions from './gridOptions'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  components: {
    AgGridWrapper
  },

  mixins: [gridOptions],

  data: () => ({
    importedSubs: null
  }),

  created() {
    apiTo.GET_SUBSCRIPTIONS_IMPORTS().then(({ data }) => (this.importedSubs = data.result))
  }
}
</script>
